import { render, staticRenderFns } from "./UserNotAllowed.vue?vue&type=template&id=52ae1de4&scoped=true"
import script from "./UserNotAllowed.vue?vue&type=script&lang=js"
export * from "./UserNotAllowed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52ae1de4",
  null
  
)

export default component.exports